/** Mobile Money networks as Paystack names them. */
export type Provider = "mtn" | "vod" | "atl";
export const PROVIDERS: { id: Provider; label: string }[] = [
  { id: "mtn", label: "MTN" },
  { id: "vod", label: "Telecel" },
  { id: "atl", label: "AirtelTigo" },
];
export const providerLabel = (p: string | null | undefined) => PROVIDERS.find((x) => x.id === p)?.label ?? "";
